import * as React from 'react';
import ROUTES from 'consts/routing';
import ConditionalRoute, {
  ConditionalRouteProps,
} from 'components/RouterProvider/ConditionalRoute';
import { connectUser } from 'components/RouterProvider/AuthorizationRoutes/connect';

const UnauthorizedRoute = ({
  isSignedIn,
  ...props
}: ConditionalRouteProps & { isSignedIn: boolean }) => {
  const isResetPasswordFlow =
    props.path === ROUTES.SET_PASSWORD ||
    props.path === ROUTES.RECOVER_PASSWORD;
  const isSharedReportFlow =
    props.path === ROUTES.PROJECT.SHARED_REPORT_PRIVATE ||
    props.path === ROUTES.PROJECT.SHARED_REPORT_PUBLIC;

  return (
    <ConditionalRoute
      isConditionSatisfied={
        isResetPasswordFlow || isSharedReportFlow ? true : !isSignedIn
      }
      {...props}
    />
  );
};

export default connectUser(UnauthorizedRoute);
